module.exports = __webpack_public_path__ + "media/images/cvtips-logo-74404e40293d57f5ee84beb13439e88c.png";